import { isArray } from 'lodash';
import { TableFiltersState } from 'types/common';

export const shouldShowBadgeForFilters = (defaultValues: TableFiltersState) =>
    Object.values(defaultValues).some((el) => (isArray(el) ? Boolean(el.length) : Boolean(el)));
